import React, { Component } from "react";
import { connect } from "react-redux";
import PropTypes from "prop-types";
import productValidation from "./validation";
import BasicInfoFields from "./components/BasicInfoFields";
import Dimensions from "./components/Dimensions";
import CreateMatrix from "./components/CreateMatrix";
import Relations from "./components/Relations";

import { Button, Container, Dimmer, Form, Loader, Message } from "semantic-ui-react";
import {
    findProducts,
    loadBrands,
    loadCountries,
    loadDimensions,
    loadProductGroups,
    loadProductCategories,
    loadSuppliers,
} from "../../../../../reducer/actions";
import {
    getBrands,
    getCountries,
    getDimensions,
    getProductGroups,
    getProductCategories,
    getProducts,
    getSuppliers,
    isLoading
} from "../../../../../reducer";
import { getTranslate } from "react-localize-redux";


class BasicInfo extends Component {

    constructor(props) {
        super(props);
        this.state = {
            product: { ...props.product },
            errors: {},
            validated: false
        };

        this.dValidate = this.debounce(this.validate, 1000);


        if (props.product.requestType === "newVintage" && !props.product.parent_id) {
            this.state.product = {
                ...props.product,
                matrixCode: "",
                createMatrix: true,
                variations: [
                    {
                        dimension_id: 5,
                        id: 1
                    },
                    {
                        dimension_id: 6,
                        id: 1
                    },
                    {
                        dimension_id: 7,
                        id: 1
                    }
                ],
                oldProductVariations: [
                    {
                        dimension_id: 5,
                        id: 1
                    },
                    {
                        dimension_id: 6,
                        id: 1
                    },
                    {
                        dimension_id: 7,
                        id: 1
                    }
                ],
            };
        }
    }

    componentDidMount() {
        this.props.loadDimensions()
            .then(() => {
                this.validate();
            });
        this.props.loadProductGroups();
        this.props.loadProductCategories();
        this.props.loadSuppliers();
        this.props.loadCountries();
        this.props.loadBrands();
    }

    resetProductField(fieldName) {
        this.setState(({ product }) => ({
                product: {
                    ...product,
                    [fieldName]: this.props.product[fieldName],
                    validated: false
                }
            }), () => {
                this.dValidate();
            }
        );
    }

    isRequiredField(fieldName) {
        const notRequiredFields = {
            create: [
                'category_id',
            ],
            newVintage: [
                'category_id',
            ],
            edit: [
                'category_id',
            ],
            newQuoteProduct: [
                'code2',
                'description',
                'manufacturerName',
                'description',
                'volume',
                'group_id',
                'category_id',
                'country_id',
                'brand_id',
            ],
        };

        // make category field required only when group is liquor
        if(fieldName === 'category_id' && this.state.product.group_id && this.state.product.group_id === 35){
            return true;
        }

        return !notRequiredFields[this.state.product.requestType].includes(fieldName);
    }


    render() {

        const { translate } = this.props;

        return <Container>
            <Dimmer active={this.props.isLoading}>
                <Loader>{translate("general.loading")}</Loader>
            </Dimmer>
            {Object.values(this.state.errors).length > 0 &&
            <Message negative header={translate("tools.general.errors.label")}
                     list={Object.values(this.state.errors)}/>
            }

            <Form onSubmit={() => {
                this.handleSubmit();
            }}>

                <BasicInfoFields context={this} translate={translate}/>
                <Relations context={this} translate={translate}/>

                {
                    !this.state.product.parent_product && this.state.product.requestType === "newVintage" && Object.keys(this.props.dimensions).length !== 0 &&

                    <CreateMatrix
                        translate={translate}
                        context={this}
                        dimensions={this.props.dimensions}
                        errors={this.state.errors}
                        product={this.state.product}
                    />

                }

                {
                    this.state.product.variations && Object.keys(this.props.dimensions).length !== 0 && !this.state.product.createMatrix &&
                    <Dimensions
                        translate={translate}
                        context={this}
                        variations={this.state.product.variations}
                        dimensions={this.props.dimensions}
                        errors={this.state.errors}
                        product={this.state.product}

                    />
                }
            </Form>

            {
                this.state.validated ?
                    <Button positive fluid onClick={() => {
                        this.complete();
                    }}>{translate("general.next")}</Button> :
                    <Button primary fluid onClick={() => {
                        this.dValidate();
                    }}>{translate("general.validate")}</Button>
            }

        </Container>;
    }

    complete() {
        this.validate()
            .then((validated) => {
                if (validated) {
                    this.props.onComplete(this.state.product);
                }
            });
    }


    validate() {

        return new Promise((resolve) => {
            productValidation.validate(this.state.product, this.props.product, this.props.dimensions, this.props.suppliers, this.props.translate, this.isRequiredField.bind(this))
                .then((errors) => {
                    try {
                        this.setState({
                            errors,
                            validated: Object.values(errors).length === 0
                        });

                        resolve(Object.values(errors).length === 0);
                    } catch (e) {
                        resolve(false);
                    }
                });
        });

    }


    debounce(a, b, c) {
        let d,
            e;
        return function () {
            function h() {
                d = c || (e = a.apply(f, g));
                if (!c) {
                    d = null;
                }
            }

            let f = this,
                g = arguments;
            clearTimeout(d);
            d = setTimeout(h, b);
            c && !d && (e = a.apply(f, g));
            return e;
        };
    }


}

BasicInfo.propTypes = {
    onComplete: PropTypes.func.isRequired,
    product: PropTypes.object.isRequired,
};

const mapStateToProps = state => ({
    translate: getTranslate(state.localize),
    isLoading: isLoading(state.tools),
    dimensions: getDimensions(state.tools),
    productGroups: getProductGroups(state.tools),
    productCategories: getProductCategories(state.tools),
    products: getProducts(state.tools),
    suppliers: getSuppliers(state.tools),
    countries: getCountries(state.tools),
    brands: getBrands(state.tools)
});


const mapDispatchToProps = (dispatch) => {
    return ({
        loadDimensions: () => (dispatch(loadDimensions())),
        findProducts: (code) => (dispatch(findProducts(code))),
        loadProductGroups: () => (dispatch(loadProductGroups())),
        loadProductCategories: () => (dispatch(loadProductCategories())),
        loadSuppliers: () => (dispatch(loadSuppliers())),
        loadBrands: () => (dispatch(loadBrands())),
        loadCountries: () => (dispatch(loadCountries()))
    });
};


export default connect(
    mapStateToProps,
    mapDispatchToProps
)(BasicInfo);



// WEBPACK FOOTER //
// ./src/scenes/Tools/scenes/MasterDataRequest/components/Steps/BasicInfos/index.js